import React, { useState } from 'react';
import { Brain } from 'lucide-react';
import {
  MessageSquare, AlertTriangle, Mail, Search, Cable,
  Sparkles, FileText, Target, DollarSign, TrendingUp, Wand2, Radar, ClipboardCheck,
} from 'lucide-react';
import {
  AiAnomalyPanel, AiOnboardingChat, AiWeeklyDigest, AiNaturalSearch, AiPathFinder,
  AiIntegrationMapperPanel, AiTechAdvisorPanel, AiContractAnalyzerPanel,
  AiRfpWriterPanel, AiVendorComparePanel, AiCostOptimizerPanel,
  AiBenchmarksPanel, AiPredictPanel,
} from './AiFeatures';
import PropertyWizard from './PropertyWizard';
import SidebarLayout from './SidebarLayout';
import VendorWatch from './VendorWatch';

import ThirtyDayAuditWizard from './ThirtyDayAuditWizard';

const AI_GROUPS = [
  { label: 'Ask & Explore', items: [
    { id: 'ask', label: 'Ask LodgiFlow', icon: Search },
    { id: 'anomalies', label: 'Anomaly Scanner', icon: AlertTriangle },
    { id: 'benchmarks', label: 'Benchmark Engine', icon: Target },
    { id: 'audit', label: '30-Day Audit', icon: ClipboardCheck },
  ]},
  { label: 'Integrations', items: [
    { id: 'pathfinder', label: 'Path Finder', icon: Cable },
    { id: 'mapper', label: 'Integration Mapper', icon: Sparkles },
    { id: 'predict', label: 'Predict Next', icon: Brain },
  ]},
  { label: 'Advisory', items: [
    { id: 'advisor', label: 'Tech Advisor', icon: Brain },
    { id: 'compare', label: 'Vendor Compare', icon: Target },
    { id: 'cost', label: 'Cost Optimizer', icon: DollarSign },
    { id: 'vendor-watch', label: 'Vendor Watch', icon: Radar },
  ]},
  { label: 'Documents', items: [
    { id: 'contract', label: 'Contract Analyzer', icon: FileText },
    { id: 'rfp', label: 'RFP Writer', icon: FileText },
  ]},
  { label: 'Communication', items: [
    { id: 'digest', label: 'Weekly Digest', icon: Mail },
    { id: 'chat', label: 'Onboarding Chat', icon: MessageSquare },
  ]},
  { label: 'Property Setup', items: [
    { id: 'property-intel', label: 'Property Intelligence', icon: Wand2 },
  ]},
];

export default function AiHub({ token, onNavigateReport, hasPermission, onNavigateTab }) {
  const allItems = AI_GROUPS.flatMap(g => g.items);
  const filteredGroups = hasPermission ? AI_GROUPS.map(g => ({ ...g, items: g.items.filter(() => true) })) : AI_GROUPS;
  const [section, setSection] = useState(allItems[0]?.id || 'ask');

  return (
    <SidebarLayout
      title="AI Assistant"
      icon={Brain}
      groups={filteredGroups}
      activeId={section}
      onSelect={setSection}
    >
      {section === 'ask' ? <AiNaturalSearch token={token} onNavigateReport={onNavigateReport} />
      : section === 'pathfinder' ? <AiPathFinder token={token} />
      : section === 'anomalies' ? <AiAnomalyPanel token={token} />
      : section === 'audit' ? <ThirtyDayAuditWizard token={token} onNavigateTab={onNavigateTab} />
      : section === 'digest' ? <AiWeeklyDigest token={token} />
      : section === 'chat' ? <AiOnboardingChat token={token} />
      : section === 'mapper' ? <AiIntegrationMapperPanel token={token} />
      : section === 'advisor' ? <AiTechAdvisorPanel token={token} />
      : section === 'contract' ? <AiContractAnalyzerPanel token={token} />
      : section === 'rfp' ? <AiRfpWriterPanel token={token} />
      : section === 'compare' ? <AiVendorComparePanel token={token} />
      : section === 'cost' ? <AiCostOptimizerPanel token={token} />
      : section === 'benchmarks' ? <AiBenchmarksPanel token={token} />
      : section === 'predict' ? <AiPredictPanel token={token} />
      : section === 'vendor-watch' ? <VendorWatch token={token} />
      : section === 'property-intel' ? <PropertyWizard token={token} onComplete={() => setSection('ask')} />
      : null}
    </SidebarLayout>
  );
}
